import { Injectable } from '@angular/core';
import { Features } from './../models';

@Injectable()
export class FeatureService {
    private features: Features;
    private eventIdAsQuoteNumberToggle: boolean = null;

    public flightSegmentsIsEnabled(): boolean {
        return true;
    }

    public isAirCareRatingId(ratingId: string): boolean {
        return this.features && this.features.airCareRatingIds && this.features.airCareRatingIds.has(ratingId);
    }

    public getDefaultFlightSegments(): number {
        return this.features ? this.features.defaultFlightSegments : 2;
    }

    public getConsumerDomain(): string {
        return this.features ? this.features.consumerDomain : '';
    }

    public setFeatures(features: Features): void {
        if (features) {
            this.features = features;
        }
    }

    /**
     * @description
     * Checks if the feature toggle for using Event ID as quote number is enabled.
     * Reads from URL parameter 'featureToggleQuoteNumber' and caches in sessionStorage.
     * @returns true if toggle is enabled, false otherwise
     */
    public isEventIdAsQuoteNumberEnabled(): boolean {
        // Return cached value if already determined
        if (this.eventIdAsQuoteNumberToggle !== null) {
            return this.eventIdAsQuoteNumberToggle;
        }

        // Check sessionStorage first
        const sessionValue = sessionStorage.getItem('featureToggleQuoteNumber');
        if (sessionValue !== null) {
            this.eventIdAsQuoteNumberToggle = sessionValue === 'true';
            return this.eventIdAsQuoteNumberToggle;
        }

        // Check URL parameter
        const urlParams = new URLSearchParams(window.location.search);
        const toggleParam = urlParams.get('featureToggleQuoteNumber');

        if (toggleParam !== null) {
            this.eventIdAsQuoteNumberToggle = toggleParam === 'true';
            // Cache in sessionStorage
            sessionStorage.setItem('featureToggleQuoteNumber', this.eventIdAsQuoteNumberToggle.toString());
            return this.eventIdAsQuoteNumberToggle;
        }

        // Default to false if not specified
        this.eventIdAsQuoteNumberToggle = false;
        return this.eventIdAsQuoteNumberToggle;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/feature.service.ts